const DEVICE_CHARACTERISTICS_SIZE_VALUES = {
    'is_extra_small': 1,
    'is_small': 2,
    'is_smallish': 2,
    'is_medium': 3,
    'is_large': 4,
    'is_extra_large': 5
};

export const DEVICE_CHARACTERISTICS_SIZE = {
    'EXTRA_SMALL': 1,
    'SMALL': 2,
    'SMALLISH': 2,
    'MEDIUM': 3,
    'LARGE': 4,
    'EXTRA_LARGE': 5
};

/**
 * Is the given val null or undefined?
 * @param  {*}  val Any JavaScript value
 * @return {boolean}     True, if the value is null or undefined; false, otherwise.
 */
export function isNullOrUndefined(val) {
    return _.isNull(val) || _.isUndefined(val);
}

/**
 * Detect IE9 or IE10 based on user agent string
 * @return {Boolean} True or false
 */
export function isLegacyIE() {
    if (window.navigator.userAgent.indexOf('MSIE 9') > -1 ||
        window.navigator.userAgent.indexOf('MSIE 10') > -1 ||
        window.navigator.userAgent.indexOf('Trident/') > -1) {
        return true;
    }

    return false;
}

export function isBlurrableElement(element) {
    const node = element.nodeName.toLowerCase();
    const formElements = ['input', 'select', 'textarea', 'a'];

    return formElements.includes(node);
}

export function isDeviceTypeLargerThan(state, deviceCharacteristicsSize) {
    const deviceCharacteristics = _.get(state, 'core.deviceCharacteristics');

    if (!deviceCharacteristics) {
        return false;
    }

    const deviceSize = _.find(Object.keys(DEVICE_CHARACTERISTICS_SIZE_VALUES), (key) => deviceCharacteristics[key] === true);

    if (!deviceSize) {
        return false;
    }

    return DEVICE_CHARACTERISTICS_SIZE_VALUES[deviceSize] > deviceCharacteristicsSize;
}

/**
 * Get the current site ID
 * @param  {object} state The current state of the redux store
 * @return {string}       The current site ID
 */
export function getSiteId(state) {
    return _.get(state, 'core.siteId');
}

/**
 * Search the data object's values and replace the specified string with a new value
 * @param  {Object} obj    Source data object
 * @param  {string} searchValue    Value to search for, value that gets replaced
 * @param  {string} newValue    New string value
 * @return {Object} Data object with replacements
 */
export function searchAndReplace(obj, searchValue = '', newValue = '') {
    let result = Object.assign({}, obj);
    if(obj && searchValue) {
        for (const key in obj) {
            const value = obj[key];
            if (value.indexOf(searchValue) > -1) {
                result[key] = value.replace(searchValue, newValue);
            }
        }
    }
    return result;
}
